import { BrowserRouter as Router } from 'react-router-dom';
import { MarTrakRoutes } from './routes/MarTrakRoutes';
//Context Providers
import { ErrorProvider } from './contexts/ErrorContext';
import { LoadingProvider } from './contexts/LoadingContext';
import { SuccessProvider } from './contexts/SuccessContext';
import { UnsavedChangesProvider } from './contexts/UnsavedChangesContext';
import { SidebarProvider } from '@contexts/SidebarContext';
//Dialog Components
import { LoadingDialog } from './components/ui/modals/LoadingDialog';
import { ErrorDialog } from './components/ui/modals/ErrorDialog';
import { SuccessDialog } from './components/ui/modals/SuccessDialog';
import { LoadingSpinner } from '@components/ui/spinner/LoadingSpinner';

function App() {

  return (
    <ErrorProvider>
      <SidebarProvider>
        <LoadingProvider>
          <SuccessProvider>
            <UnsavedChangesProvider>
              <Router>
                <ErrorDialog />
                <LoadingDialog />
                <LoadingSpinner />
                <SuccessDialog />
                <MarTrakRoutes />
              </Router>
            </UnsavedChangesProvider>
          </SuccessProvider>
        </LoadingProvider>
      </SidebarProvider>
    </ErrorProvider>
  );
}

export default App;